import { render } from "./EmergencyContacts.vue?vue&type=template&id=4c1ab8ce&ts=true"
import script from "./EmergencyContacts.vue?vue&type=script&lang=ts"
export * from "./EmergencyContacts.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__